import { CustomFieldType, TranslationMarkupFormat, } from '@tribeplatform/gql-client/types';
import { logger } from '../../common/lib/logger';
export const getTranslatableFields = (postFields, networkFields) => postFields.reduce((acc, cur) => {
    try {
        const field = networkFields.find(field => field.key === cur.key);
        const value = JSON.parse(cur.value);
        if (value && field) {
            if (field.type === CustomFieldType.richText) {
                return {
                    ...acc,
                    [cur.key]: {
                        markup: value,
                        format: TranslationMarkupFormat.HTML,
                    },
                };
            }
            if (field.type === CustomFieldType.text) {
                return {
                    ...acc,
                    [cur.key]: {
                        markup: value,
                        format: TranslationMarkupFormat.TEXT,
                    },
                };
            }
        }
    }
    catch (e) {
        logger.error('Error parsing member field value', e.message);
    }
    return acc;
}, {});
export const getTranslatedPost = (post, translatedFieldsData, translatableFields) => {
    var _a;
    const translatedFields = (_a = post === null || post === void 0 ? void 0 : post.fields) === null || _a === void 0 ? void 0 : _a.map(field => {
        const translatableKeyIndex = Object.keys(translatableFields).indexOf(field === null || field === void 0 ? void 0 : field.key);
        if (translatableKeyIndex !== -1) {
            return {
                key: field === null || field === void 0 ? void 0 : field.key,
                value: JSON.stringify(translatedFieldsData[translatableKeyIndex]),
            };
        }
        return field;
    });
    return { ...post, fields: translatedFields };
};
export const getTranslatedPostTypeName = ({ $t }, fieldName) => {
    const knownPostField = fieldName;
    switch (knownPostField) {
        case 'Apply link':
            return $t({
                defaultMessage: 'Apply link',
                id: 'DefaultPostFields.Label.ApplyLink',
            });
        case 'Assignee':
            return $t({
                defaultMessage: 'Assignee',
                id: 'DefaultPostFields.Label.Assignee',
            });
        case 'Category':
            return $t({
                defaultMessage: 'Category',
                id: 'DefaultPostFields.Label.Category',
            });
        case 'Company':
            return $t({
                defaultMessage: 'Company',
                id: 'DefaultPostFields.Label.Company',
            });
        case 'Content':
            return $t({
                defaultMessage: 'Content',
                id: 'DefaultPostFields.Label.Content',
            });
        case 'Cover image':
            return $t({
                defaultMessage: 'Cover image',
                id: 'DefaultPostFields.Label.CoverImage',
            });
        case 'Date':
            return $t({
                defaultMessage: 'Date',
                id: 'DefaultPostFields.Label.Date',
            });
        case 'Date & time':
            return $t({
                defaultMessage: 'Date & time',
                id: 'DefaultPostFields.Label.DateAndTime',
            });
        case 'Department':
            return $t({
                defaultMessage: 'Department',
                id: 'DefaultPostFields.Label.Department',
            });
        case 'Description':
            return $t({
                defaultMessage: 'Description',
                id: 'DefaultPostFields.Label.Description',
            });
        case 'Employment type':
            return $t({
                defaultMessage: 'Employment type',
                id: 'DefaultPostFields.Label.EmploymentType',
            });
        case 'Event link':
            return $t({
                defaultMessage: 'Event link',
                id: 'DefaultPostFields.Label.EventLink',
            });
        case 'Hosts':
            return $t({
                defaultMessage: 'Hosts',
                id: 'DefaultPostFields.Label.Hosts',
            });
        case 'Location':
            return $t({
                defaultMessage: 'Location',
                id: 'DefaultPostFields.Label.Location',
            });
        case 'Release date':
            return $t({
                defaultMessage: 'Release date',
                id: 'DefaultPostFields.Label.ReleaseDate',
            });
        case 'Remote':
            return $t({
                defaultMessage: 'Remote',
                id: 'DefaultPostFields.Label.Remote',
            });
        case 'Resolved':
            return $t({
                defaultMessage: 'Resolved',
                id: 'DefaultPostFields.Label.Resolved',
            });
        case 'Salary range':
            return $t({
                defaultMessage: 'Salary range',
                id: 'DefaultPostFields.Label.SalaryRange',
            });
        case 'Status':
            return $t({
                defaultMessage: 'Status',
                id: 'DefaultPostFields.Label.Status',
            });
        case 'Tags':
            return $t({
                defaultMessage: 'Tags',
                id: 'DefaultPostFields.Label.Tags',
            });
        case 'Title':
            return $t({
                defaultMessage: 'Title',
                id: 'DefaultPostFields.Label.Title',
            });
        case 'Type':
            return $t({
                defaultMessage: 'Type',
                id: 'DefaultPostFields.Label.Type',
            });
        case 'Version':
            return $t({
                defaultMessage: 'Version',
                id: 'DefaultPostFields.Label.Version',
            });
        case 'Website':
            return $t({
                defaultMessage: 'Website',
                id: 'DefaultPostFields.Label.Website',
            });
        default: {
            const uknownPostField = knownPostField;
            return $t({
                defaultMessage: '<capital>{post_type}</capital>',
                id: 'PostType.Name',
            }, {
                post_type: uknownPostField,
            });
        }
    }
};
//# sourceMappingURL=postTranslate.js.map